import React, { useState } from 'react';
import sLogoImg from '../images/s-logo.png';
import { useFPlanStats } from '../hooks/useStats';
import { formatPrice } from '../helper/contractHelper';
import { ethers } from 'ethers';
import { formatDateWithZone, TOKEN_DECIMALS } from '../helper/constant';
import { toast } from 'react-toastify';
import { getContract } from '../helper/contractHelper';
import tokenAbi from '../json/token.json';
import { contract, DEFAULT_CHAIN } from '../helper/constant';
import { getWeb3 } from '../helper/connectors';
import stakeAbi from '../json/tokenstake.json';
import { useEffect } from 'react';
import { useAccount } from 'wagmi';
import { useEthersSigner } from '../hooks/useEthersProvider';
import moneyBagImg from '../images/money-bag.png';
import { useAppKitNetwork } from '@reown/appkit/react';




export default function ForeverPlan({ updater, setUpdater, accStats }) {
    const stats = useFPlanStats(updater);
    const { address: account } = useAccount()
    const { chainId } = useAppKitNetwork()
    const library = useEthersSigner();
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);
    const [loading, setLoading] = useState(false);

    const handleApprove = async (e) => {
        e.preventDefault();
        if (account) {
            if (parseInt(chainId) === parseInt(DEFAULT_CHAIN)) {
                try {
                    setLoading(true);
                    let tokenContract = getContract(tokenAbi, contract[DEFAULT_CHAIN].TOKEN_ADDRESS, library);
                    let amount = ethers.utils.parseUnits(stats.foreverPlanInvest.toString(), TOKEN_DECIMALS)
                    let tx = await tokenContract.approve(contract[DEFAULT_CHAIN].STAKE_ADDRESS, amount, { 'from': account });
                    toast.loading('waiting for confirmation..');
                    var interval = setInterval(async function () {
                        let web3 = getWeb3();
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                toast.dismiss();
                                toast.success('success ! your last transaction is success 👍');
                                setUpdater(Math.random());
                                setLoading(false);
                            }
                            else if (response.status === false) {
                                toast.dismiss();
                                toast.error('error ! Your last transaction is failed.');
                                setUpdater(Math.random());
                                setLoading(false);
                            }
                            else {
                                toast.dismiss();
                                toast.error('error ! something went wrong.');
                                setUpdater(Math.random());
                                setLoading(false);
                            }
                        }
                    }, 5000);

                }
                catch (err) {
                    toast.dismiss();
                    toast.error(err.reason ? err.reason : err.message);
                    setLoading(false);
                }
            }
            else {
                toast.dismiss();
                toast.error('Please select Smart Chain Network !');
                setLoading(false);
            }

        }
        else {
            toast.dismiss();
            toast.error('Please Connect Wallet!');
            setLoading(false);
        }
    }

    const handleStake = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {

            if (account) {
                if (parseInt(chainId) === parseInt(DEFAULT_CHAIN)) {
                    if (parseFloat(accStats.tokenBalance) >= parseFloat(stats.foreverPlanInvest)) {
                        let stakeContract = getContract(stakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS, library);
                        let tx = await stakeContract.ForeverMiningPlan({ 'from': account });
                        toast.loading('Waiting for confirmation...');

                        var interval = setInterval(async function () {
                            let web3 = getWeb3();
                            var response = await web3.eth.getTransactionReceipt(tx.hash);
                            if (response != null) {
                                clearInterval(interval)
                                if (response.status === true) {
                                    toast.dismiss();
                                    toast.success('success ! your last transaction is success 👍');
                                    setUpdater(Math.random());
                                    setLoading(false);
                                }
                                else if (response.status === false) {
                                    toast.dismiss();
                                    toast.error('error ! Your last transaction is failed.');
                                    setUpdater(Math.random());
                                    setLoading(false);
                                }
                                else {
                                    toast.dismiss();
                                    toast.error('error ! something went wrong.');
                                    setUpdater(Math.random());
                                    setLoading(false);
                                }
                            }
                        }, 5000);

                    }
                    else {
                        toast.dismiss();
                        toast.error('you don\'t have enough balance !');
                        setLoading(false);
                    }

                }
                else {
                    toast.dismiss();
                    toast.error('Please select Smart Chain Network !');
                    setLoading(false);
                }
            }
            else {
                toast.dismiss();
                toast.error('Please Connect Wallet!');
                setLoading(false);
            }

        }
        catch (err) {
            toast.dismiss();
            console.log(err);
            toast.error(err.reason ? err.reason : err.message);
            setLoading(false);
        }
    }


    const handleClaimReward = async () => {
        setLoading(true);
        try {

            if (account) {
                if (parseInt(chainId) === parseInt(DEFAULT_CHAIN)) {

                    let stakeContract = getContract(stakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS, library);
                    let tx = await stakeContract.claimReward({ 'from': account });
                    toast.loading('Waiting for confirmation...');

                    var interval = setInterval(async function () {
                        let web3 = getWeb3();
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                toast.dismiss();
                                toast.success('success ! your last transaction is success 👍');
                                setUpdater(Math.random());
                                setLoading(false);
                            }
                            else if (response.status === false) {
                                toast.dismiss();
                                toast.error('error ! Your last transaction is failed.');
                                setUpdater(Math.random());
                                setLoading(false);
                            }
                            else {
                                toast.dismiss();
                                toast.error('error ! something went wrong.');
                                setUpdater(Math.random());
                                setLoading(false);
                            }
                        }
                    }, 5000);



                }
                else {
                    toast.dismiss();
                    toast.error('Please select Smart Chain Network !');
                    setLoading(false);
                }
            }
            else {
                toast.dismiss();
                toast.error('Please Connect Wallet!');
                setLoading(false);
            }

        }
        catch (err) {
            toast.dismiss();
            console.log(err);
            toast.error(err.reason ? err.reason : err.message);
            setLoading(false);
        }
    }

    useEffect(() => {
        let interval;
        if (accStats.fPlan) {
            interval = setInterval(() => {
                setUpdater(Math.random());
            }, 10000);
        }

        return () => interval && clearInterval(interval)
        // eslint-disable-next-line
    }, [accStats])


    return (
        <div className="row">
            <div className="col-12">
                <div className="align-items-center d-flex flex-wrap flex-sm-nowrap w-100 gap-2 gap-sm-4">
                    <div className="fs-21 flex-shrink-0">
                        Amount to be Mining:
                    </div>
                    <div className="input-staked d-flex w-100 border rounded-8 p-2">
                        <input type="text" className="form-control border-0" value={stats.foreverPlanInvest} readOnly={true} />
                        <button className='max-btn' type='button'>MAX Plan</button>
                        <img src={sLogoImg} className="img-fluid" alt="s-logo" style={{ "width": "45px" }} />
                    </div>
                </div>
                {/* <h5 className='fs-21 mt-2 fw-normal mb-4 mb-sm-5 ml-254 text-danger mt-3'><small>{error_msg}</small></h5> */}
                <h5 className='fs-21 mt-2 fw-normal mb-4 mb-sm-5 ml-254 text-danger mt-3'><small></small></h5>

                <div className="fs-21 mt-2 fw-normal mb-4 mb-sm-5 ml-254">Available: {accStats.tokenBalance ? formatPrice(accStats.tokenBalance) : 0} MCASH</div>

                <div className="fs-21 mt-2 fw-bold mb-3 mb-sm-4 ml-254 ml-0">Mining Summary</div>
                {accStats.fPlan ? (
                    <div className="ml-254 ml-0">
                        <div className="table-grid">
                            <div>
                                <div>Duration</div>
                                <div>:</div>
                                <div> {Math.ceil(stats.forever_plan / 365)} Years</div>
                            </div>
                            <div>
                                <div>Time Left</div>
                                <div>:</div>
                                <div>{accStats.fPlan_endTime - Math.floor(new Date().getTime() / 1000.0) > 0 ? formatPrice(Math.round(Math.abs((accStats.fPlan_endTime - Math.floor(new Date().getTime() / 1000.0)) / 86400))) : 0} Days</div>
                            </div>
                            <div>
                                <div>Withdraw Fees</div>
                                <div>:</div>
                                <div>{stats.claimFees ? stats.claimFees : 0} MCASH</div>
                            </div>
                            <div>
                                <div>Reward</div>
                                <div>:</div>
                                <div>{accStats.totalClamied ? formatPrice(accStats.totalClamied) : 0} MCASH</div>
                            </div>
                            <div style={{ color: "#1252D4", fontWeight: "bold" }}>
                                <div>Pending</div>
                                <div>:</div>
                                <div className='d-flex align-items-center gap-1'>
                                    <img src={moneyBagImg} height="28px" width="28px" className="img-fluid" alt="money-bag" />
                                    {accStats.userPendingReward ? formatPrice(accStats.userPendingReward) : 0} MCASH
                                </div>
                            </div>
                            <div>
                                <div>Start Date</div>
                                <div>:</div>
                                <div>{accStats.fPlan_startTime ? formatDateWithZone(accStats.fPlan_startTime * 1000) : ''}</div>
                            </div>
                            <div>
                                <div>End Date</div>
                                <div>:</div>
                                <div>{accStats.fPlan_endTime ? formatDateWithZone(accStats.fPlan_endTime * 1000) : ''}</div>
                            </div>
                        </div>
                        <button disabled={loading} onClick={() => handleClaimReward()} className="confirm-btn btn btn-primary h-48 w-100 my-4 my-sm-5">
                            {loading ? 'LOADING...' : 'CLAIM REWARD'}
                        </button>
                    </div>
                ) : (
                    <div className="ml-254 ml-0">
                        <div className="table-grid">
                            <div>
                                <div>Duration</div>
                                <div>:</div>
                                <div> {stats.forever_plan / 365} Years</div>

                            </div>
                            <div>
                                <div>Mining Amount</div>
                                <div>:</div>
                                <div>{stats.foreverPlanInvest ? formatPrice(stats.foreverPlanInvest) : 0} MCASH </div>
                            </div>
                            <div>
                                <div>Mining Return</div>
                                <div>:</div>
                                <div>{formatPrice(stats.forever_plan * 86400 * stats.rewardRate)} MCASH</div>
                            </div>
                            <div>
                                <div>Withdraw Fees</div>
                                <div>:</div>
                                <div>{stats.claimFees ? stats.claimFees : 0} MCASH</div>
                            </div>
                            <div>
                                <div>Start Date</div>
                                <div>:</div>
                                <div>{today.toString()}</div>
                            </div>
                            <div>
                                <div>End Date</div>
                                <div>:</div>
                                <div>{new Date(parseInt(timeElapsed) + parseInt(stats.forever_plan * 86400 * 1000)).toString()}</div>
                            </div>
                        </div>
                        {accStats.fPlan ? (
                            <button disabled={true} className="confirm-btn btn btn-primary h-48 w-100 my-4 my-sm-5">
                                Mining Now
                            </button>
                        ) : (
                            accStats.sPlan && Math.floor(new Date().getTime() / 1000.0) >= parseInt(accStats.sPlan_endTime) ? (parseFloat(accStats.isApprove) < parseFloat(stats.foreverPlanInvest) ? (
                                <button disabled={loading} className="confirm-btn btn btn-primary h-48 w-100 my-4 my-sm-5" onClick={(e) => handleApprove(e)}>
                                    {loading ? 'LOADING...' : 'APPROVE'}
                                </button>
                            ) : (
                                <button disabled={loading} className="confirm-btn btn btn-primary h-48 w-100 my-4 my-sm-5" onClick={(e) => handleStake(e)}>
                                    {loading ? 'LOADING...' : 'MINING NOW'}
                                </button>
                            )) : (
                                <>
                                    <button disabled={true} className="confirm-btn btn btn-primary h-48 w-100 mt-5 mb-1">
                                        MINING NOW
                                    </button>
                                    <p className='text-danger text-sm'>Note : For activate forever plan need to activate starter plan , after starter plan endtime you can invest in forver plan.</p>
                                </>
                            )
                        )}
                    </div>
                )}

            </div>
        </div>
    )
}
